import React from "react";
import cn from "classnames";

export interface TooltipWrapperProps {
  className?: string;
}

export interface TooltipProps {
  active: boolean;
  className?: string;
}

export const TooltipWrapper: React.FC<TooltipWrapperProps> = ({
  children,
  className,
}) => {
  return (
    <div className={cn("relative", className)}>
      {React.Children.toArray(children)}
    </div>
  );
};

export const Tooltip: React.FC<TooltipProps> = ({
  children,
  active,
  className,
}) => {
  return null;

  /* todo 
  return active ? (
    <div className={cn("dynamic-center-x z-50 shadow bg-red text-white text-xs rounded py-1 px-4 right-0", className)}>
      <svg
        x="0"
        y="0"
        className="absolute text-red h-2 w-full left-0 bottom-full negative-scale-100"
        viewBox="0 0 255 255"
      >
        <path d="M0 0L127.5 127.5 255 0z" className="fill-current"></path>
      </svg>
      {React.Children.toArray(children)}
    </div>
  ) : null;
  */
};
